<template>
  <div class="w-screen h-screen overflow-x-auto overflow-y-hidden snap-x snap-mandatory bg-(image:--bg-green-url) bg-top bg-cover bg-no-repeat flex flex-col">
    <div class="flex justify-center items-center py-6 px-5 sticky left-0 gap-x-4 gap-y-2 flex-wrap" ref="naslov_koledarja">
      <div v-html="svgContents['kuponi-in-akcije']" class="flex justify-center items-center" :style="'height:' + visina_naslova/2 + 'px'"></div>
      <div v-html="svgContents['vsak-dan']" class="flex justify-center items-center" :style="'height:' + visina_naslova/2 + 'px'"></div>
    </div>
    <div class="flex grow mx-12 md:mx-auto justify-around"  :style="'width:' + sirina_osnova + 'px'" id="spar-koledar-ugodnosti-container">
      <div v-for="(dan, dan_v_tednu) in dnevi" ref="dneviKoledarja" :data-observer-index="dan_v_tednu" class="relative snap-center"
      :class="{
        'scale-[0.9]': dan_v_tednu != (aktiven_dan-1),
        'top-[2%]' : dan_v_tednu == (aktiven_dan-1)
        }"
      :style="'width:' + sirina_stolpca + 'px'">
        <div ref="fontsizecontainers" class="flex justify-center gap-x-2 text-sparred" :style="'font-size:' + dnevi_font_size + 'px'">
          <span ref="fontsizedatenames" class="uppercase whitespace-nowrap font-black">{{ dan.name }}</span>
          <span ref="fontsizedates" class="uppercase whitespace-nowrap font-regular">{{ dan.date }}</span>
        </div>
        <div v-for="(promocija, vrstni_red) in promocije[dan_v_tednu]" class="relative p-2 w-full group" v-bind:class="{'drop-shadow-[0_5px_10px_rgba(0,0,0,0.5)]' : dan_v_tednu == (aktiven_dan-1), 'shadow-[0_4px_20px_0_rgba(0,0,0,0.25)]' : dan_v_tednu != (aktiven_dan-1)}"
        :style="{
        width: sirina_stolpca + 'px',
        height: vrstni_red == 0 ? visina_prva_vrstica + 'px' : visina_vrstica + 'px',
        'z-index': (50 - vrstni_red)
        }"
        :class="{
          'bg-kupon25':   promocija == 'kupon25',
          'bg-kupon10':   promocija == 'kupon10',
          'bg-upokojenci10':   promocija.includes('upokojenci') || promocija == 'praznik',
          'bg-praznicnipopusti': promocija == 'praznicnipopusti',
          'bg-kupon30nf2':   promocija == 'kupon30nf2',
          'bg-szt':       promocija == 'szt',    
          'bg-sst':       promocija == 'sst',    
          'bg-skt':       promocija == 'skt',    
          'bg-svp':       promocija == 'svp',   
          'bg-sparas': promocija == 'sparas',
          'bg-ribljitorek': promocija == 'ribjitorek',
          'bg-[radial-gradient(circle_at_50%_50%,#ec684a,#e30814)]':promocija == 'ekstra-sreda',
        }"
        >
          <a target="_parent":href="anchorTags[promocija] ? anchorTags[promocija] : 'https://www.spar.si'" class="">
            <div v-html="svgContents[promocija]" 
              class="h-full w-full transition-transform duration-300 transform group-hover:scale-105"
              :class="{
                'drop-shadow-[0_6px_6px_rgba(0,0,0,0.7)]': promocija.includes('kupon') || promocija.includes('sparas')
              }">
            </div>
          </a>
        </div>
        <div v-if="dan_v_tednu == 2" class="relative">
          <a target="_parent" href="https://www.spar.si/letak">
            <Letak :stevilo_izdelkov="stevilo_izdelkov" class="absolute -top-2 drop-shadow-[6px_2px_6px_rgba(0,0,0,0.7)]" :style="{
              'z-index': 50
            }"/>
          </a>
        </div>
      </div>
    </div>
    <div class="fixed w-full flex-row justify-center z-55" :style="'bottom:' + (1*dnevi_font_size) + 'px'"
    :class="sirina_osnova > win_width ? 'flex' : 'hidden'">
      <div class="flex w-3/4 justify-center items-center">
        <div v-for="(dan, dan_v_tednu) in dnevi" class="flex size-8 mx-2 justify-center items-center" @click="scrollHere(dan_v_tednu)">
        <div class="bg-sparbutton rounded-full cursor-pointer transition-colors duration-150 ease-in-out drop-shadow-[2px_4px_4px_rgba(0,0,0,0.9)]"
        :class="{
          'bg-sparbuttonactive': dan_v_pogledu == dan_v_tednu,
          'hover:bg-sparbuttonhover': dan_v_pogledu != dan_v_tednu,
          'size-4': dan_v_tednu != (aktiven_dan-1),
          'size-2 outline-2 outline-offset-4 outline-sparbutton': dan_v_tednu == (aktiven_dan-1)
        }"></div>
      </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watch, useTemplateRef } from "vue";
import { getISOWeek, getISOWeekYear, getISOWeeksInYear, startOfISOWeek, endOfISOWeek, addDays, format } from "date-fns";
//letak je edini kot komponenta, ker se spreminjajo številke
import Letak from "@/components/Letak.vue";

let fetch_url = import.meta.env.VITE_FETCH_ROOT_DEV;
if(import.meta.env.PROD)
{
  fetch_url = import.meta.env.VITE_FETCH_ROOT_PROD;
}

const app_container = import.meta.env.VITE_APP_CONTAINER;

const dnevi = ref([
  {"name":"Ponedeljek", "date":""},
  {"name":"Torek", "date":""},
  {"name":"Sreda", "date":""},
  {"name":"Četrtek", "date":""},
  {"name":"Petek", "date":""},
  {"name":"Sobota", "date":""},
]);
const svgContents = ref({});
const win_width = ref(0);
const aktiven_teden = ref(1);
const aktiven_dan = ref(0);
const dan_v_pogledu = ref(0);
const promocije = ref([]);
const stevilo_izdelkov = ref(850);
const anchorTags = ref({});
const rowCount = ref(0);
const visina_osnova = ref(36);
const sirina_osnova = ref(49);
const visina_naslova = ref(1);
const visina_koledarja = ref(1);
const visina_prva_vrstica = ref(1);
const sirina_stolpca = ref(1);
const visina_vrstica = ref(1);
const dnevi_font_size = ref(50);
const leto = ref(2024);
const dneviKoledarja = useTemplateRef('dneviKoledarja');
const fontsizecontainers = useTemplateRef('fontsizecontainers');
const fontsizedatenames = useTemplateRef('fontsizedatenames');
const fontsizedates = useTemplateRef('fontsizedates');

onMounted(async () => {
    win_width.value = window.innerWidth;
    await teden();
    await nextTick();
    const allSvgNames = await loadData(aktiven_teden.value);
    let uniqueSvgNames = [...new Set(allSvgNames.flat())];
    await loadSvgs(uniqueSvgNames);
    visina_osnova.value = parseInt(window.getComputedStyle(document.getElementById(app_container), null).getPropertyValue("height"));
    window.addEventListener("resize", windowResizing);
    await nextTick();
    await proportion();
    const koledarUgodnostiContainer = document.getElementById("spar-koledar-ugodnosti-container").parentNode;
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          scrollHere(aktiven_dan.value-1);
          observer.disconnect();
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });
    observer.observe(koledarUgodnostiContainer);
    //scrollHere(this.aktiven_dan-1);
    setupIntersectionObserver();
  })

watch(
  visina_osnova,
  async () => {
    visina_naslova.value = parseInt(visina_osnova.value * 0.08);
    await nextTick();
    visina_koledarja.value = parseInt(window.getComputedStyle(document.getElementById("spar-koledar-ugodnosti-container"), null).getPropertyValue("height"));
  }
)

function setupIntersectionObserver() {
  const items = dneviKoledarja.value;

  const observerOptions = {
    root: document.getElementById("spar-koledar-ugodnosti-container").parentNode,
    rootMargin: '0px',
    threshold: 0.9,
  };

  const observer = new IntersectionObserver((entries) => {
    let closestElement = null;
    let closestDistance = Infinity;

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const rect = entry.target.getBoundingClientRect();
        const viewportCenter = window.innerWidth / 2;
        const elementCenter = rect.left + rect.width / 2;
        const distance = Math.abs(viewportCenter - elementCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestElement = entry.target;
        }
      }
    });

    if (closestElement) {
      dan_v_pogledu.value = closestElement.dataset['observerIndex'];
    }
  }, observerOptions);

  items.forEach((item) => observer.observe(item));
}

function windowResizing() {
  visina_osnova.value = parseInt(window.getComputedStyle(document.getElementById(app_container), null).getPropertyValue("height"));
  proportion();
}

function scrollHere(el_index) {
  if (el_index < 0)
  {
    el_index = 0;
  }
  dan_v_pogledu.value = el_index;
  dneviKoledarja.value[el_index].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
}

// async methods
async function teden() {
  const mode = import.meta.env.MODE;
  
  let d = new Date(); // production/staging
  //let d = new Date(Date.parse("2024-12-21")); // dev
  const isoWeeksInYear = getISOWeeksInYear(d);
  aktiven_dan.value = d.getDay();
  aktiven_teden.value = getISOWeek(d);
  leto.value = getISOWeekYear(d);
  
  // ce je nedelja, prikazi naslednji teden
  if (d.getDay() == 0){
    d = addDays(d, 1);
    aktiven_teden.value = getISOWeek(d);
    leto.value = getISOWeekYear(d);
  }
  
  const startOfWeek = startOfISOWeek(d);
  const endOfWeek = endOfISOWeek(d);
  
  for (let i = 1; i < 7; i++){
    dnevi.value[i-1].date = format(addDays(startOfWeek, (i-1)), 'd.M.');
  }

  if (mode === 'staging') {
    aktiven_dan.value = 0;
    aktiven_teden.value++;
    
    if (aktiven_teden.value > isoWeeksInYear) {
      leto.value++;
      aktiven_teden.value = 1;
    }
    
    const stagingDate = addDays(d, 7);

    const startOfWeek = startOfISOWeek(stagingDate);
    const endOfWeek = endOfISOWeek(stagingDate);

    for (let i = 1; i < 7; i++) {
      dnevi.value[i-1].date = format(addDays(startOfWeek, (i-1)), 'd.M.');
    }
  }
}

async function rowNum() {
  //stevilo vrstic, brez datuma
  let maxLength = 0;
  promocije.value.forEach(element => {
    if (element.length > maxLength)
    {
      maxLength = element.length;
    }        
  });
  // +1 za letak ce je sreda najdaljsa
  if (promocije.value[2].length == maxLength)
  {
    rowCount.value = maxLength+1;
  }
  else
  {
    rowCount.value = maxLength;
  }

  //min mora biti 4
  rowCount.value = Math.max(4, rowCount.value);
}
async function proportion() {
  await rowNum();
  
  let one_row_height = visina_koledarja.value / rowCount.value;
  let one_column_width = (49 / 36) * one_row_height;
  sirina_stolpca.value = one_column_width;
  let sirina = 6 * one_column_width;
  sirina_osnova.value = parseInt(sirina);
  visina_prva_vrstica.value = one_row_height;
  visina_vrstica.value = one_column_width / (49 / 31);
  await nextTick();
  let offset_root = fontsizecontainers.value[0].offsetWidth;
  let offset_sum = fontsizedatenames.value[0].offsetWidth + fontsizedates.value[0].offsetWidth;
  
  while ((offset_sum > offset_root) && (dnevi_font_size.value > 12)) {
    dnevi_font_size.value = dnevi_font_size.value-2;
      await nextTick();
      offset_sum = fontsizedatenames.value[0].offsetWidth + fontsizedates.value[0].offsetWidth;
  }
}

async function loadData(teden) {
  // uvoz podatkov za teden
  let data_url = fetch_url + (`${leto.value}/teden-${teden}.json`);
  let response = await fetch(data_url);
  const file = await response.json();
  
  if (response.ok) {
    promocije.value = file['promocije'];
    stevilo_izdelkov.value = file['stevilo_izdelkov'];
    anchorTags.value = file['anchorTags'];
  }
  
  return file['promocije'];
}

async function loadSvgs(svg_files) {
  //svg_files.push("ugodnosti-vsak-dan");
  svg_files.push("kuponi-in-akcije");
  svg_files.push("vsak-dan");
  
  for (const svg_file of svg_files) {
    let data_url = fetch_url + 'assets/' + svg_file + '.svg';
    let response = await fetch(data_url);
    const svgContent = await response.text();
    
    if (response.ok) {
      svgContents.value[svg_file] = svgContent;
    }
  }
}

</script>